import { motion } from "framer-motion";
import { TrendingUp, TrendingDown, Activity } from "lucide-react";
import { usePrice, fmtPrice, fmtCompact } from "@/hooks/usePrice";

export const PriceTicker = () => {
  const { data, state, change, up } = usePrice();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.05 }}
      className="mt-8 inline-flex flex-wrap items-stretch gap-px rounded-xl overflow-hidden border border-white/15 bg-black/60 backdrop-blur-md"
      data-testid="price-ticker"
    >
      {/* Token label */}
      <div className="px-5 py-3 flex items-center bg-white/5">
        <span className="font-display font-extrabold text-xs sm:text-sm uppercase tracking-tight text-white">
          Screaming Chicken
        </span>
      </div>

      {/* Live price */}
      <div className="px-5 py-3 flex items-center gap-3 border-l border-white/10">
        <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#39ff14]">
          <Activity className="w-3 h-3" />
          Live
        </span>
        <span className="font-mono font-bold text-lg sm:text-xl text-white tabular-nums" data-testid="price-value">
          {state === "ok" ? fmtPrice(data.priceUsd) : state === "loading" ? "···" : "--"}
        </span>
      </div>

      {/* 24h change */}
      <div className="px-5 py-3 flex items-center gap-2 border-l border-white/10">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">24h</span>
        {state === "ok" ? (
          <span
            className={`flex items-center gap-1 font-mono font-bold text-sm tabular-nums ${
              up ? "text-[#39ff14]" : "text-[#ff007f]"
            }`}
            data-testid="price-change"
          >
            {up ? <TrendingUp className="w-3.5 h-3.5" /> : <TrendingDown className="w-3.5 h-3.5" />}
            {up ? "+" : ""}
            {change.toFixed(2)}%
          </span>
        ) : (
          <span className="font-mono text-sm text-white/40">--</span>
        )}
      </div>

      {/* Market cap */}
      <div className="px-5 py-3 flex items-center gap-2 border-l border-white/10">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">MCap</span>
        <span className="font-mono font-bold text-sm text-[#00f0ff] tabular-nums" data-testid="price-mcap">
          {state === "ok" ? fmtCompact(data.marketCap ?? data.fdv) : "--"}
        </span>
      </div>

      {state === "empty" && (
        <div className="px-5 py-3 flex items-center border-l border-white/10">
          <span className="font-mono text-[10px] text-[#ffb800] uppercase tracking-wider">
            Fresh mint · pumping soon
          </span>
        </div>
      )}
    </motion.div>
  );
};
